import React, { useEffect, useState } from "react";
import ErrorFullScreenMessage from "../fullScreenMessage/ErrorFullScreenMessage";
import Loader from "../loader/Loader";
import { CircularProgress, Skeleton } from "@mui/material";
import FullScreenMessageCore from "../fullScreenMessage/FullScreenMessageCore";
import { BiSolidErrorAlt } from "react-icons/bi";
import { CRIMSON_RED } from "../../enums/Colors.jsx";
import { useTranslation } from "react-i18next";
import PawPrint from "../display/PawPrint.jsx";

export default function DisplayChecker({data, error, loading, children, fullScreen = true, skeleton = true, numOfSkeletons, sHeight, sWidth, delayLoading = 0}) {
  const { t } = useTranslation();
  const [showLoader, setShowLoader] = useState(true);
  const [loadingCount, setLoadingCount] = useState(0);

  useEffect(() => {
    // If loading is true or data is null, show the loader only on the first load
    if (loading || data == null) {
      if (loadingCount === 0) {
        setShowLoader(true);
      }
    } else {
      // Stop showing the loader and increase the loading count after the first load
      const timeout = setTimeout(() => {
        setShowLoader(false);
        setLoadingCount((prev) => prev + 1);
      }, delayLoading);

      return () => clearTimeout(timeout);
    }
  }, [loading, data, delayLoading, loadingCount]);

  if (error) {
    if (typeof error === "string" && error.includes("Network Error")) {
      return <ErrorFullScreenMessage />;
    }
    return (
      <FullScreenMessageCore
        icon={<BiSolidErrorAlt size={150} color={CRIMSON_RED} />}
        title={t("SomethingWentWrongErrorTemplateTitle")}
        subtitle={t("SomethingWentWrongErrorTemplateSubtitle")}
      />
    );
  }

  // Show the loader only on the first load
  if (showLoader && loadingCount === 0) {
    if (fullScreen) {
      return <Loader  />;
    } else if (skeleton) {
      return (
        <>
          {Array.from({ length: numOfSkeletons }, (_, index) => (
            <Skeleton
              key={index}
              sx={{ width: sWidth ?? "100%", height: sHeight ?? 120 }}
            />
          ))}
        </>
      );
    } else {
      return <Loader />;
    }
  }

  return <>{children}</>;
}
